// ###### IMPORTS
import React from 'react';
import CardOverviewKeyMessage from './viewComponents/CardOverviewKeyMessage';
import CardOverviewFlow from './viewComponents/CardOverviewFlow';
import CardOverviewBudget from './viewComponents/CardOverviewBudget';
import CardOverviewAssets from './viewComponents/CardOverviewAssets';

// ###### MAIN COMPONENT
const TabFinanceOverview = ({ onNavigateToFlow, onNavigateToBudget, onNavigateToAssets }) => {
  return (
    <div className="p-0 flex flex-col gap-2 w-full mt-2">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <CardOverviewKeyMessage />
        <CardOverviewFlow onNavigateToFlow={onNavigateToFlow} />
        <CardOverviewBudget onNavigateToBudget={onNavigateToBudget} />
        <CardOverviewAssets onNavigateToAssets={onNavigateToAssets} />
      </div>
    </div>
  );
};

export default TabFinanceOverview;